import {
    BaseTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/base-transition-model';
import { IAnimationSetting } from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';

export class EmptyTransitionModel extends BaseTransitionModel {
    type = TransitionType.EMPTY;
    public getAnimationSetting(): IAnimationSetting[] {
        return [];
    }
}
